const AppVersion = {"version": "v1.4.0"}; export default AppVersion;